import { MenuItem, menuItems } from '../menu/menu.config';

// Mirrors the main desktop menu (menu.config.ts) 1:1, so the two views never drift apart —
// any item added, removed, or reordered there is reflected here automatically.
export const mobileMenuItems: MenuItem[] = menuItems;
